// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.disable-events {\n  pointer-events: none;\n}\n.v-btn.my-btn {\n  min-width: 20px !important;\n}\n", ""]);
// Exports
module.exports = exports;
